import React, {useEffect, useState, useMemo} from 'react';
import {useNavigate} from 'react-router';
import {Container, Stack, Typography} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {useQueryParam} from '../../util/react_hooks.js';
import api from '../../util/api.js';
import {getEnv} from '../../util.js';
import {LoaderComp} from '../../components/Loader.js';
import {withTitle} from '../../title.js';
import withMainContainer from '../../components/WithMainContainer.js';
import SCButton from '../../components/SCButton.js';
import config from '../../config.js';

const TarotmailPostPurchaseComp = props=>{
    let {data, userEmail, loading} = props;
    let navigate = useNavigate();
    let [ipn] = useQueryParam('ipn');
    let envName = useMemo(()=>getEnv());
    if (data?.status=='expired')
    {
        return <>
          <ErrorOutlineIcon color="error" sx={{fontSize: 100}}/>
          <Typography variant="h3" textAlign="center">
            פג תוקף הקישור
          </Typography>
        </>;
    }
    if (data?.payment?.status=='COMPLETE')
    {
        return <>
          <TaskAltIcon color="success" sx={{fontSize: 100}}/>
          <Typography variant="h3" textAlign="center">
            תודה על הרכישה
          </Typography>
          {userEmail&&<Typography textAlign="center">
            פרטי התחברות וקבלה נשלחו למייל <b>{userEmail}</b>
          </Typography>}
          <Stack direction="row" flexWrap="wrap" gap={2} justifyContent="center" alignItems="center">
            {data.payment.docUrl&&<SCButton variant="outlined" text="הורדת קבלה"
              icon={<DownloadIcon/>}
              onClick={()=>window.open(data.payment.docUrl)}/>}
            {data.verified&&<SCButton variant="contained" text="המשך לאפליקציית המסרים"
              icon={<ChevronLeftIcon/>}
              onClick={()=>navigate('/tarotmail/student')}/>}
          </Stack>
        </>;
    }
    if (data?.payment?.status=='PENDING')
    {
        return <>
          <LoaderComp/>
          <Typography textAlign="center">
            התשלום מתבצע, זה יקח רק כמה רגעים...
          </Typography>
          {envName=='DEV'&&<SCButton text="Test IPN"
            onClick={()=>api.tarotmail.ext.testIpn({external_data: ipn})}/>}
        </>;
    }
    if (loading)
        return <LoaderComp/>;
};

const TarotmailPostPurchase = ()=>{
    let [data, setData] = useState();
    let [loading, setLoading] = useState();
    let [paymentId] = useQueryParam('payment_id');
    let [paymentToken] = useQueryParam('payment_token');
    let [userEmail] = useQueryParam('user_email');
    useEffect(()=>{
        if (!paymentId||!paymentToken)
            return;
        setLoading(true);
        let es, itvl;
        let connect = ()=>{
            es = new EventSource(
                `${config.API_BASE}tarotmail/payment/${paymentId}/events?paymentToken=${paymentToken}`);
            es.onerror = e=>{
                console.error('EventSource error', e);
                itvl = setTimeout(()=>connect(), 3000);
            };
            es.addEventListener('waiting', ()=>setData({payment: {status: 'PENDING'}}));
            es.addEventListener('purchase_complete', ev=>{
                setData(JSON.parse(ev.data));
                setLoading(false);
                es.close();
            });
        };
        connect();
        return ()=>{
            clearTimeout(itvl);
            setLoading(false);
            es.close();
        };
    }, [paymentId, paymentToken]);
    return <Container maxWidth="lg">
      <Stack direction="column" alignItems="center" gap={2}
        marginBottom={8} marginTop={5}>
        <TarotmailPostPurchaseComp data={data}
          userEmail={userEmail} loading={loading}/>
      </Stack>
    </Container>;
};

export default withTitle('אפליקציית המסרים', withMainContainer(TarotmailPostPurchase));
